@if (enabled) {
  <app-update-policy-status-modal
    [policy]="policy"
    [status]="PolicyStatus.ARCHIVED"
    titleText="Archiver cette police ?"
    i18n-titleText
    (updateSuccess)="refreshTaskDetails()"
  >
    <app-trash-2-icon
      height="16px"
      width="16px"
      color="var(--light-gray-500)"
      ngbTooltip="Archiver la police"
      i18n-ngbTooltip
      trigger
    />
  </app-update-policy-status-modal>
}
